export default "__VITE_ASSET__BRoyuvuB__"